import { cn } from "@/utils/css";
import { useIsDarkTheme } from "@/components/layout/useIsDarkTheme";

export const Skeleton = ({ className = "" }) => {
    const isDarkTheme = useIsDarkTheme();

    return (
        <div
            className={cn(`relative overflow-hidden w-full h-full ${className}`, {
                "bg-[#1F2321]": isDarkTheme,
                "bg-[#F1F4F3]": !isDarkTheme,
            })}
        >
            <div
                className={cn("absolute inset-0 animate-shimmer bg-gradient-to-r", {
                    "from-[#1F2321] via-[#131414] to-[#1F2321]": isDarkTheme,
                    "from-[#F1F4F3] via-[#FFFFFF] to-[#F1F4F3]": !isDarkTheme,
                })}
            />
        </div>
    );
};
